const getBrowserLanguage = () => {
  return navigator.language;
};

export default getBrowserLanguage;
